import React, {useEffect} from 'react'
import styles from './HistoryPage.module.css'
import axios from "axios";
import LoadingBackdrop from "../../../../components/common/LoadingBackdrop";
import {
    Alert, AlertColor,
    Container, Grid, MenuItem, Select, SelectChangeEvent,
} from "@mui/material";

import Snackbar from "@mui/material/Snackbar";
import {DataGridPremium} from "@mui/x-data-grid-premium";
import {GridColDef, GridToolbarContainer} from "@mui/x-data-grid-pro";

const HistoryPage = (params) => {
    const [loadingBackdrop, setLoadingBackdrop] = React.useState(false)
    const [snackbarOpen, setSnackbarOpen] = React.useState<{ open: boolean, message: string, type: AlertColor }>({ open: false, message: '', type: 'success' })
    const [timeEntryGridSetting, setTimeEntryGridSettings] = React.useState({timeentrylist: [], fieldlist: [], weekendlist: []})
    const [timeEntryGridColumns, setTimeEntryGridColumns] = React.useState<GridColDef[]>([])
    const [activeWeekend, setActiveWeekend] = React.useState('');

    useEffect(() => {
        params.setTitle('History')
        getGridSettings(null)
    }, [])


    useEffect(() => {
        if (params.displayHistory) {
            params.setBackArrow('timeentry')
        }
    }, [params.backArrowClick])

    const getGridSettings = (weekendid) => {
        debugger
        var body = {}
        if (weekendid) {
            body['weekend'] = weekendid
        }
        axios.post(`fieldsystemtimehistory`, body).then((response) => {
            const parsedResponse = JSON.parse(response?.data.jsonString)
            debugger
            const newTimeEntryList = parsedResponse?.timeentrylist.map(tel => {
                return {...tel, id: tel.timeentryid}
            })
            debugger

            const newTimeColumns = parsedResponse?.fieldlist?.map(fl => {
                return {
                    field: fl.schedulefield,
                    type: 'string', // use schedulefieldcontrol which  is  a number of control type
                    headerName: fl.schedulefieldlabel,
                    width: fl.width,
                    align: fl.align,
                    headerAlign: fl.headeralign,
                }
            })
            debugger

            setActiveWeekend(parsedResponse?.selectedweekend)
            setTimeEntryGridColumns(newTimeColumns)
            setTimeEntryGridSettings({...parsedResponse, timeentrylist: newTimeEntryList})
        })
    }

    const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        // if (reason === 'clickaway') {
        //     return;
        // }

        setSnackbarOpen({ open: false, message: "", type: 'success' });
    }

    const handleWeekendChange = (event: SelectChangeEvent) => {
        setActiveWeekend(event.target.value)
        getGridSettings(event.target.value)
    }

    const getWeekendOptions = () => {
        const menuItemsToAdd = timeEntryGridSetting?.weekendlist?.map(item => (
            <MenuItem key={item.weekend} value={item.weekend}>
                {item.weekendinfo}
            </MenuItem>
        ))
        return [
            ...menuItemsToAdd
        ]
    }

    function CustomGridToolbar() {
        return (
            <GridToolbarContainer >
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-begin"
                    alignItems="center"
                >
                    <Grid item xs={4} padding={0} spacing={0}>
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-begin"
                            alignItems="center"
                        >
                            <Grid item xs={12} padding={0} spacing={0}>
                                <Select
                                    onChange={handleWeekendChange}
                                    style={{ width: '100%', height:'30px' }}
                                    value={activeWeekend}
                                >
                                    {getWeekendOptions()}
                                </Select>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </GridToolbarContainer>
        )
    }


    return (
        <div className={styles.root}>
            <LoadingBackdrop open={loadingBackdrop} />
            {snackbarOpen.open &&
                <Snackbar
                    open={true}
                    autoHideDuration={4000}
                    onClose={handleClose}
                    anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                >
                    <Alert severity={snackbarOpen.type}>
                        {snackbarOpen.message}
                    </Alert>
                </Snackbar>
            }

            <div style={{display: loadingBackdrop ? 'none' : 'inline-flex'}}>
                <DataGridPremium
                    rows={timeEntryGridSetting?.timeentrylist}
                    columns={timeEntryGridColumns}
                    autoHeight={true}
                    density={'compact'}
                    pageSize={25}
                    loading={false}
                    disableMultipleSelection={true}
                    // onRowClick={handleRowClick}
                    // onRowDoubleClick={handleRowClick}
                    components={{
                        Toolbar: CustomGridToolbar,
                    }}
                />
            </div>
        </div>
    )
}

export default HistoryPage